module.exports = __webpack_public_path__ + "static/media/Dollhouse_level_1.63a7690f.jpg";